import classNames from 'classnames';

import AccordionItem, { AccordionItemIconType } from './AccordionItem';
import { AccordionFragmentFragment } from '../../__generated__/graphql';
import { Paragraph } from '../../components/Text';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';
import { ContentBlock } from '../types';

import style from './accordion.module.css';

const Accordion: ContentBlock<AccordionFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.accordion;
  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor={contentBlockProps.darkBackground ? 'black' : 'white'}
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.accordion}
    >
      <SectionTitle className={style.accordionTitle}>
        {contentBlockProps.title}
      </SectionTitle>

      {contentBlockProps.description && (
        <Paragraph
          className={style.accordionSubtitle}
          fontSize={15}
        >
          {contentBlockProps.description}
        </Paragraph>
      )}

      <ul
        className={classNames(
          style.accordionList,
          contentBlockProps.darkBackground ? style.accordionListDarkBackground : style.accordionListLightBackground,
        )}
      >
        {contentBlockProps.items?.map(item => {
          if (item) {
            const iconType = contentBlockProps.iconType?.[0] as AccordionItemIconType | null | undefined;

            return (
              <li key={item.title}>
                <AccordionItem
                  content={item.content ?? ''}
                  iconType={iconType ?? 'Chevron'}
                  title={item.title ?? ''}
                  withAbbreviation={!!contentBlockProps.withAbbreviations}
                  withDarkBackground={!!contentBlockProps.darkBackground}
                  withLargeItemTitle={!!contentBlockProps.withLargeItemTitle}
                />
              </li>
            );
          }
        })}
      </ul>
    </Section>
  );
};

export default Accordion;
